(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["band-new"] && !Shopify.designMode) return;
  try {
    
function initBandSection() {
  var wrappers = document.querySelectorAll('.band-items-wrapper');
  wrappers.forEach(function (wrapper) {
    wrapper.style.opacity = '1';

    if (wrapper.dataset.bandInit === 'true') return;
    wrapper.dataset.bandInit = 'true';

    try {
      var items = wrapper.children;
      var itemCount = items.length;
      var enableMarquee = itemCount >= 6 && window.innerWidth > 1100;

      if (enableMarquee) {
        var cloneCount = itemCount;
        for (var i = 0; i < cloneCount; i++) {
          var clone = items[i].cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          wrapper.appendChild(clone);
        }

        wrapper.classList.add('marquee');
        var totalItems = wrapper.children.length;
        var duration = Math.max(10, Math.round(totalItems * 1.2 + 6));
        wrapper.style.display = 'flex';
        wrapper.style.animation = 'band-marquee ' + duration + 's linear infinite';
        wrapper.style.willChange = 'transform';
        Array.prototype.forEach.call(wrapper.children, function (el) {
          el.style.opacity = 1;
          el.style.transform = 'none';
          el.style.animation = 'none';
        });
      }
    } catch (e) {
      console.warn('Band marquee init failed', e);
    }
  });
}

document.addEventListener('DOMContentLoaded', initBandSection);
// Re-run when the section is (re)rendered inside the theme editor,
// since editor updates swap the DOM without firing DOMContentLoaded.
document.addEventListener('shopify:section:load', initBandSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grading-example"] && !Shopify.designMode) return;
  try {
    
(function() {

  var root = document.getElementById('ms-premium-grading');
  if (!root) return;

  var track = root.querySelector('#ms-condition-track');
  var prev  = root.querySelector('#ms-condition-prev');
  var next  = root.querySelector('#ms-condition-next');
  var dots  = root.querySelectorAll('.ms-condition-dot');

  if (!track || !prev || !next) return;

  var cards   = track.querySelectorAll('.ms-condition-card');
  var total   = cards.length;
  var current = 0;

  function visibleCount() {
    var width = root.offsetWidth;
    if (width <= 600) return 1;
    if (width <= 1050) return 2;
    return 4;
  }

  function update() {
    var visible  = visibleCount();
    var maxSlide = Math.max(0, total - visible);
    current = Math.min(current, maxSlide);

    var gap = 15;
    var cardWidth = (track.parentElement.offsetWidth - gap * (visible - 1)) / visible;

    track.style.transform = 'translateX(-' + (current * (cardWidth + gap)) + 'px)';

    dots.forEach(function(dot, index) {
      dot.classList.toggle('is-active', index === current);
    });

    prev.disabled = current === 0;
    next.disabled = current >= maxSlide;
  }

  prev.addEventListener('click', function() {
    if (current > 0) { current--; update(); }
  });

  next.addEventListener('click', function() {
    var maxSlide = Math.max(0, total - visibleCount());
    if (current < maxSlide) { current++; update(); }
  });

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      current = parseInt(this.dataset.index, 10);
      update();
    });
  });

  window.addEventListener('resize', update);
  update();

})();

  } catch(e) { console.error(e); }
})();
})();
